import { FunctionComponent, ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const TASKS_TITLE_ACTIONS_ID = 'tasks-title-actions';

export const TasksTitlePortal: FunctionComponent<{ children: ReactNode }> = props => {
    const [target, setTarget] = useState<HTMLElement | null>(null);

    useEffect(() => {
        setTarget(document.getElementById(TASKS_TITLE_ACTIONS_ID));
    }, []);

    return target ? createPortal(props.children, target) : null;
};

export default TasksTitlePortal;
